import { createUseStyles } from 'react-jss';
import { DESKTOP_FONT_SIZES, GLOBAL_LETTER_SPACING, } from '@/styles/themes/components';
import { INSURANCE_DESKTOP_BREAKPOINT } from '../../styles';
export const ASIDE_NAVIGATION_PADDING = 5;
export const useStyles = createUseStyles((theme) => ({
    root: {
        display: 'none',
        [theme.breakpoints.up(INSURANCE_DESKTOP_BREAKPOINT)]: {
            display: 'initial',
        },
    },
    container: {
        backgroundColor: theme.colors.cloud,
        boxShadow: theme.elevations.cloud,
        isolation: 'isolate',
        padding: ASIDE_NAVIGATION_PADDING,
        borderRadius: 12,
        minWidth: 170,
        maxWidth: 200,
        width: 'calc(39vw - 300px)',
        transition: theme.transition.global,
    },
    navigation: {
        display: 'flex',
        width: '100%',
        height: 'max-content',
        flexDirection: 'column',
    },
    tab: {
        borderRadius: 8,
        padding: 8,
        textAlign: 'left',
        width: '100%',
        position: 'relative',
        transition: theme.transition.global,
        '&:disabled': {
            opacity: 0.55,
            cursor: 'not-allowed',
        },
        '& span': {
            color: theme.colors.brand,
            fontSize: DESKTOP_FONT_SIZES.main,
            letterSpacing: GLOBAL_LETTER_SPACING,
            zIndex: 1,
            position: 'relative',
        },
        '&[data-active="true"]': {
            cursor: 'default',
        },
    },
    highlighter: {
        inset: 0,
        backgroundColor: theme.colors.brandTertiary,
        position: 'absolute',
        borderRadius: 8,
    },
}), { name: 'aside' });
